import type { FaireProductEntity } from "../../entity_types/product";

export const p_gcjbbxexhy: FaireProductEntity = {
  token: "p_gcjbbxexhy",
  type: "product",
  name: "Round Enamel Tray - Eye",
  brandToken: "b_u89gdyfh23",
  brandName: "Roomytown Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/a08e09a6c7530f43baf744eeb6e3531c68c62a0508f8a60f531dc6b7606f475c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/024ffec4f98d12a925a43d7d14d488738dad943be234050e2658519d87448208.jpeg",
    "https://cdn.faire.com/fastly/d892ef5e9873ca1066fccdfee7dc3d509c02cb7015c3f31038026e06d5fe4306.jpeg",
    "https://cdn.faire.com/fastly/fc5e3690151a8e372079586c600204de38671997ba6fa94258a300c353614d70.jpeg",
  ],
  priceDollars: 8,
  description:
    'This decorative \'Eye\' Enamel Tray will bring instant personality into your home. Perfect home accessory for holding jewellery, stationery and other small trinkets.\n\nH 120mm x W 250mm x D 15mm / H 4.7" x W 9.8" x D 0.6"\n\n*Each of our enamel trays is expertly handcrafted in India. Due to the nature of this handmade production process, please expect some variation in the final product.',
  tags: [],
  msrpDollars: 17.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:40:43.142Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
